module.exports = __webpack_public_path__ + "img/pic_nostudent@2x.eb214729.png";